import { render } from "./ProfileSettingsSheet.vue?vue&type=template&id=a561c0f8&ts=true"
import script from "./ProfileSettingsSheet.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__